import React  from "react";
import { buildProductPagination } from "../../utils/productPagination";

const ButtonPagination = ({
    size,
    skip,
    limit,
    siseProduct,
    loadMore,
    loadMore0,
    infoSource,
    buttonClassL = 'btn btn-primary  pt-2 pb-2 pr-2 pl-2 rounded-4 float-left',
    buttonClassLD = 'btn pt-2 pb-2 pr-2 pl-2 rounded-4 float-left',
    buttonClassR = 'btn btn-primary pt-2 pb-2 pr-2 pl-2  rounded-4  float-right',
    buttonClassRD = 'btn pt-2 pb-2 pr-2 pl-2 rounded-4 float-right'
}) => {


const loadMoreButton = () => {
    const isActive = buildProductPagination({
        size,
        skip,
        limit,
        totalProducts: siseProduct,
    }).hasNextPage;
    return (
        <button
            onClick={isActive ? loadMore : undefined}
            className={isActive ? buttonClassR : buttonClassRD}
            style={{ width: "120px" }}
            disabled={!isActive}
        >
            {infoSource.laguangeElakay('Button', infoSource.languageAPI).next}
        </button>
    );
};

const loadMoreButton0 = () => {
    const isActive = buildProductPagination({
        size,
        skip,
        limit,
        totalProducts: siseProduct,
    }).hasPreviousPage;
    return (
        <button
            onClick={isActive ? loadMore0 : undefined}
            className={isActive ? buttonClassL : buttonClassLD}
            style={{ width: "120px" }}
            disabled={!isActive}
        >
            {infoSource.laguangeElakay('Button', infoSource.languageAPI).previous}
        </button>
    );
};
    return (
        <div className="row justify-content-center">
            <div className="col col-sm-8 col-lg-5">
                <div className="bg clearfix ">
                    {loadMoreButton0()}
                    {loadMoreButton()}
                </div>
            </div></div>
    )
};

export default ButtonPagination;
